<mp-select
  class="facet-type-select"
  [options]="bucketSelectOptions()"
  [selectedValue]="selectedTypeFacetBucket()"
  (selectedValueChange)="onBucketSelected($event)"
  [customCompareWithFunction]="compareByVal"
  (click)="$event.stopPropagation()"
/>
